<template>
  <form-field :attribute="attribute" type="phone" :label="label" :required="required" :errorKeys="errorKeys">
    <div class="phone-fields">
      <select>
        <option value="" v-text="translations.formSelectPlaceholder"></option>
        <option
          v-for="{ isoCode, name, phonePrefix } in phone_options"
          :value="phonePrefix"
          v-text="`${name} (${phonePrefix})`"
          :key="isoCode"
        ></option>
      </select>

      <input type="tel" v-model="masked_number" />
    </div>
  </form-field>
</template>

<script>
import countryPhonePrefixes from "country-phone-prefix";
import countries from "i18n-iso-countries/entry-node";
import { createMask } from "imask";
import { get, map } from "lodash";
import { REGISTRATION_UPDATE } from "../../store/types";
import ActsAsFormField from "../../mixins/ActsAsFormField";
import HasSelectizeInstance from "../../mixins/HasSelectizeInstance";
import HasTranslatedText from "../../mixins/HasTranslatedText";

const maskField = (field, maskOptions) => {
  const mask = createMask(maskOptions);

  return {
    get: function() {
      return mask.resolve(this[field]);
    },
    set: function(value) {
      mask.resolve(value);
      this[field] = mask.unmaskedValue;
    },
  };
};

export default {
  mixins: [ActsAsFormField, HasSelectizeInstance, HasTranslatedText],

  watch: {
    prefix: "updateState",
    number: "updateState",
  },

  data() {
    const fullNumber = this.$store.getters.getRegistrationValue(this.attribute);
    let [prefix, number] = fullNumber
      .replace(/^\+/, "")
      .trim()
      .split(/\s+/);

    if (number === undefined && prefix.length > 4) {
      // it's likely no prefix has been set, so we have to swap the variable assignment
      number = prefix;
      prefix = undefined;
    }

    return {
      prefix,
      number: number || "",
      mask: {
        mask: "(000) 000 - 0000",
        lazy: false,
      },
    };
  },

  computed: {
    masked_number: maskField("number", {
      mask: "(000) 000-0000",
    }),

    phone_options() {
      const LANG_CODE = get(window, "vueBridge.langCode", "en");
      const countryNames = countries.getNames(LANG_CODE, { select: "official" });
      const phonePrefixes = Object.values(countryPhonePrefixes);

      return map(countryNames, (value, key) => {
        const phonePrefix = phonePrefixes.find(phonePrefix => phonePrefix.iso2 === key);

        return {
          isoCode: key,
          name: value,
          phonePrefix: phonePrefix && phonePrefix.prefix ? phonePrefix.prefix : null,
        };
      }).filter(country => country.phonePrefix);
    },
  },

  methods: {
    updateSelection() {
      this.prefix = this.$selectize.getValue();
    },

    updateState() {
      const payload = { [this.attribute]: `+${this.prefix} ${this.number}` };

      this.$store.commit(REGISTRATION_UPDATE, { payload });
    },

    // override the default functionality from HasSelectizeInstance, passing the
    // locally parsed value from the store.
    initiallySelectedItems() {
      return [this.prefix];
    },
  },
};
</script>
